import { useNavigate, useParams } from 'react-router-dom';
// Types
import Paths from 'types/Paths';

const useNavigateTo = () => {
  const { slug, groupSlug } = useParams<{ slug:string, groupSlug:string }>();
  const navigate = useNavigate();

  const navigateTo = (path?:Paths, params:any = {}, nextGroupSlug?:string) => {
    let url = checkPath(slug, groupSlug || nextGroupSlug, path);
    const searchParams:URLSearchParams = new URLSearchParams();
    if ( Object.values(params).length ){
      Object.keys(params).forEach((key:string) => {
        if ( params[key] !== '' ) searchParams.append(key, params[key]);
      });
      url = `${url}?${searchParams}`;
    }
    navigate(url);
  }

  return navigateTo;
}

export default useNavigateTo;

const checkPath = (slug:string | undefined, groupSlug:string | undefined, path?:Paths) => {
  const url = `/quiz/${slug}`;

  if ( path === 'start' ) return url;

  switch (path) {
    case 'quiz-group':
      return `${url}/quiz-group/${groupSlug}`;
    case 'quiz-group-leaderboard':
      return `${url}/quiz-group-leaderboard/${groupSlug}`;
    default:
      return `${url}/${path}`;
  }
}